
<template>
  <div>
    <div class="monitorContainer">
      <!-- <div class="monitorBox">
        <appmonitor
          source="http://www.playvs.cbstudy.cn/QBJYAPP/stream01.m3u8?auth_key=1601039551-0-0-76a38d2763569c270307b4246e2b0b7c"
        ></appmonitor>
      </div> -->
      <video id="videoElement"  muted ></video>
    </div>
  </div>
</template>

<script>
import appmonitor from "@/views/antiCheating/minitor.vue";
import flvjs from "flv.js";
export default {
  data() {
    return { hls: {} };
  },
  components: {
    appmonitor,
  },
  created() {},
  mounted() {
    if (flvjs.isSupported()) {
      var videoElement = document.getElementById("videoElement");
      var flvPlayer = flvjs.createPlayer({
        type: "flv",
        isLive: true,
        // hasAudio: true,
        // hasVideo: true,
        // enableStashBuffer: true,
        url:
          "http://www.playvs.cbstudy.cn/QBJYAPP/stream.flv?auth_key=1603256808-0-0-e5dc6cd440238845d609e8223a34ef00",
      });

      flvPlayer.attachMediaElement(videoElement);

      flvPlayer.load();
      console.log(flvPlayer);
      // setTimeout(() => {
        flvPlayer.play();
      // }, 1000);
    }
  },
  methods: {},
};
</script>

<style scoped lang="less">
.monitorContainer {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  .monitorBox {
    width: 31%;
    margin: 10px 1%;
  }
}
</style>
